import { useState } from "react";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell, Legend } from "recharts";
import { SideDrawer } from "../../../component/SideDrawer/SideDrawer"; // adjust path
import DateRangePicker from "../DateRangePicker";
import { formatCurrency } from "../../../utils/utils";

export default function MyPieChart({ invoice, setStartDate, setEndDate }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const groupedData = invoice.reduce((acc, item) => {
    const date = new Date(item.invoiceDate).toISOString().split("T")[0];
    const total = parseFloat(item.total) || 0;

    if (!acc[date]) {
      acc[date] = 0;
    }
    acc[date] += total;
    return acc;
  }, {});

  const sortedData = Object.entries(groupedData)
    .map(([date, total]) => ({
      name: date,
      value: total,
    }))
    .sort((a, b) => new Date(b.name) - new Date(a.name));

  const pieData = sortedData.slice(0, 5);

  const COLORS = [
    "#8884d8", "#82ca9d", "#ffc658", "#ff8042",
    "#00C49F", "#FFBB28", "#FF8042"
  ];

  return (
    <div className="bg-white p-5 pb-8 md:h-[320px] h-[400px] w-full">
      <div className="flex flex-row justify-between items-center">
        <h5 className="md:text-[20px] text-[20px] font-bold text-gray-800">
          Day wise Invoice Revenue
        </h5>
        {/* <Filter
          className="cursor-pointer"
          onClick={() => setIsDrawerOpen(true)}
        /> */}
      </div>

      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={90}
            fill="#8884d8"
            label={({ name, value }) => `${formatCurrency(value)}`}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(val) => formatCurrency(val)} />
          <Legend
            content={({ payload }) => (
              <div className="flex flex-wrap justify-center text-xs md:text-sm mt-2 bg-white md:mb-0 mb-10">
                {payload.map((entry, index) => (
                  <div
                    key={`item-${index}`}
                    className="flex items-center mx-2 my-1"
                  >
                    <span
                      className="w-3 h-3 inline-block mr-2 rounded"
                      style={{ backgroundColor: entry.color }}
                    />
                    <span>{entry.value}</span>
                  </div>
                ))}
              </div>
            )}
          />
        </PieChart>
      </ResponsiveContainer>

      <SideDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Filter Options"
        customWidth
      >
        <div className="px-12">
          <DateRangePicker
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>
      </SideDrawer>
    </div>
  );
}
